// Sorento assets (imported from Figma "Sorento" — node 5610:73863).
// Exterior: 5 mosaic images, one per slot (big-left, mid-top, mid-bottom, right-top, right-bottom).
import sorentoExterior1 from "../../../assets/img/models/sorento/exterior/sorento-exterior-1.webp";
import sorentoExterior2 from "../../../assets/img/models/sorento/exterior/sorento-exterior-2.webp";
import sorentoExterior3 from "../../../assets/img/models/sorento/exterior/sorento-exterior-3.webp";
import sorentoExterior4 from "../../../assets/img/models/sorento/exterior/sorento-exterior-4.webp";
import sorentoExterior5 from "../../../assets/img/models/sorento/exterior/sorento-exterior-5.webp";
// Exterior mobile: portrait crops for the mobile slider (Figma node 5612:99622).
import sorentoExterior1Mobile from "../../../assets/img/models/sorento/exterior/sorento-exterior-1-mobile.webp";
import sorentoExterior2Mobile from "../../../assets/img/models/sorento/exterior/sorento-exterior-2-mobile.webp";
import sorentoExterior3Mobile from "../../../assets/img/models/sorento/exterior/sorento-exterior-3-mobile.webp";
import sorentoExterior4Mobile from "../../../assets/img/models/sorento/exterior/sorento-exterior-4-mobile.webp";
import sorentoExterior5Mobile from "../../../assets/img/models/sorento/exterior/sorento-exterior-5-mobile.webp";
// Interior / Características: 5 real interior images (mosaic has 5 slots).
import sorentoInterior1 from "../../../assets/img/models/sorento/interior/sorento-interior-1.webp";
import sorentoInterior2 from "../../../assets/img/models/sorento/interior/sorento-interior-2.webp";
import sorentoInterior3 from "../../../assets/img/models/sorento/interior/sorento-interior-3.webp";
import sorentoInterior4 from "../../../assets/img/models/sorento/interior/sorento-interior-4.webp";
import sorentoInterior5 from "../../../assets/img/models/sorento/interior/sorento-interior-5.webp";
// Interior mobile: portrait crops for the mobile slider (Figma node 5612:99622).
import sorentoInterior1Mobile from "../../../assets/img/models/sorento/interior/sorento-interior-1-mobile.webp";
import sorentoInterior2Mobile from "../../../assets/img/models/sorento/interior/sorento-interior-2-mobile.webp";
import sorentoInterior3Mobile from "../../../assets/img/models/sorento/interior/sorento-interior-3-mobile.webp";
import sorentoInterior4Mobile from "../../../assets/img/models/sorento/interior/sorento-interior-4-mobile.webp";
import sorentoInterior5Mobile from "../../../assets/img/models/sorento/interior/sorento-interior-5-mobile.webp";
import sorentoAtributesMain from "../../../assets/img/models/sorento/atributes/sorento-atributes-main.webp";
import sorentoAtributesMobile from "../../../assets/img/models/sorento/atributes/sorento-atributes-mobile.webp";
// Sorento colour renders (360° Visualiser variants)
import sorentoColorMineralBlue from "../../../assets/img/models/sorento/colors/sorento-color-mineral-blue.webp";
import sorentoColorDenimBlue from "../../../assets/img/models/sorento/colors/sorento-color-denim-blue.webp";
import sorentoColorSandBrown from "../../../assets/img/models/sorento/colors/sorento-color-sand-brown.webp";
import sorentoColorAuroraBlackPearl from "../../../assets/img/models/sorento/colors/sorento-color-aurora-black-pearl.webp";
import sorentoColorInterstellarGray from "../../../assets/img/models/sorento/colors/sorento-color-interstellar-gray.webp";
import sorentoColorSteelGray from "../../../assets/img/models/sorento/colors/sorento-color-steel-gray.webp";
import sorentoColorSnowWhitePearl from "../../../assets/img/models/sorento/colors/sorento-color-snow-white-pearl.webp";
// Carousel (Dimensiones): desktop + mobile views, one per Figma "Vista".
import sorentoCarouselFrontDesktop from "../../../assets/img/models/sorento/carousel/sorento-front-desktop.webp";
import sorentoCarouselFrontMobile from "../../../assets/img/models/sorento/carousel/sorento-front-mobile.webp";
import sorentoCarouselSideDesktop from "../../../assets/img/models/sorento/carousel/sorento-side-desktop.webp";
import sorentoCarouselSideMobile from "../../../assets/img/models/sorento/carousel/sorento-side-mobile.webp";
import sorentoCarouselBackDesktop from "../../../assets/img/models/sorento/carousel/sorento-back-desktop.webp";
import sorentoCarouselBackMobile from "../../../assets/img/models/sorento/carousel/sorento-back-mobile.webp";
import sorentoHero from "../../../assets/img/models/sorento/hero/sorento-desktop.webp";
import sorentoHeroMobile from "../../../assets/img/models/sorento/hero/sorento-mobile.webp";
// Sorento documents
import sorentoFichaTecnica from "../../../assets/fichas/Ficha técnica Sorento.pdf";
import sorentoFolleto from "../../../assets/fichas/Folleto Sorento.pdf";
// Sorento hero video assets — not delivered yet, the hero uses a static image until they land.
// import sorentoHeroVideoDesktop from "../../../assets/videos/sorento-hero-desktop.mp4";
// import sorentoHeroVideoMobile from "../../../assets/videos/sorento-hero-mobile.mp4";

export const sorentoImages = {
  carousel: {
    front: {
      desktop: sorentoCarouselFrontDesktop,
      mobile: sorentoCarouselFrontMobile,
    },
    back: {
      desktop: sorentoCarouselBackDesktop,
      mobile: sorentoCarouselBackMobile,
    },
    side: {
      desktop: sorentoCarouselSideDesktop,
      mobile: sorentoCarouselSideMobile,
    },
  },
  exterior: {
    image1: {
      desktop: sorentoExterior1,
      mobile: sorentoExterior1Mobile,
    },
    image2: {
      desktop: sorentoExterior2,
      mobile: sorentoExterior2Mobile,
    },
    image3: {
      desktop: sorentoExterior3,
      mobile: sorentoExterior3Mobile,
    },
    image4: {
      desktop: sorentoExterior4,
      mobile: sorentoExterior4Mobile,
    },
    image5: {
      desktop: sorentoExterior5,
      mobile: sorentoExterior5Mobile,
    },
  },
  interior: {
    image1: {
      desktop: sorentoInterior1,
      mobile: sorentoInterior1Mobile,
    },
    image2: {
      desktop: sorentoInterior2,
      mobile: sorentoInterior2Mobile,
    },
    image3: {
      desktop: sorentoInterior3,
      mobile: sorentoInterior3Mobile,
    },
    image4: {
      desktop: sorentoInterior4,
      mobile: sorentoInterior4Mobile,
    },
    image5: {
      desktop: sorentoInterior5,
      mobile: sorentoInterior5Mobile,
    },
  },
  colors: {
    mineralBlue: sorentoColorMineralBlue,
    denimBlue: sorentoColorDenimBlue,
    sandBrown: sorentoColorSandBrown,
    auroraBlackPearl: sorentoColorAuroraBlackPearl,
    interstellarGray: sorentoColorInterstellarGray,
    steelGray: sorentoColorSteelGray,
    snowWhitePearl: sorentoColorSnowWhitePearl,
  },
  attributes: {
    desktop: sorentoAtributesMain,
    mobile: sorentoAtributesMobile,
  },
  heroImage: { desktop: sorentoHero, mobile: sorentoHeroMobile },
  // Pending delivery: hero video and etiqueta de eficiencia.
  heroVideo: null,
  etiqueta: null,
  fichas: sorentoFichaTecnica,
  folleto: sorentoFolleto,
};
